import type { ExcelColumnMapping } from './types';
import { DON_HANG_STATUS_MAP } from './constant';
import { formatDate } from '@/lib/formatUtils';

export const DON_HANG_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Trạng thái',
    width: 16,
    resolver: row => DON_HANG_STATUS_MAP[row.status] || row.status || ''
  },
  {
    header: 'Số c/từ',
    width: 18,
    resolver: row => row.so_ct || ''
  },
  {
    header: 'Ngày c/từ',
    width: 16,
    resolver: row => formatDate(row.ngay_ct)
  },
  {
    header: 'Mã khách hàng',
    width: 18,
    resolver: row => row.ma_kh_data?.customer_code || row.ma_kh || ''
  },
  {
    header: 'Tên khách hàng',
    width: 28,
    resolver: row => row.ma_kh_data?.customer_name || row.ten_kh || ''
  },
  {
    header: 'Diễn giải',
    width: 40,
    resolver: row => row.dien_giai || ''
  },
  {
    header: 'Tổng khối lượng',
    width: 18,
    resolver: row =>
      row.t_khoi_luong !== null && row.t_khoi_luong !== undefined && row.t_khoi_luong !== ''
        ? Number(row.t_khoi_luong)
        : ''
  },
  {
    header: 'Tổng tiền',
    width: 18,
    resolver: row => Number(row.t_tt_nt || row.t_tt || 0)
  },
  {
    header: 'Ngoại tệ',
    width: 12,
    resolver: row => row.ma_nt_data?.ma_nt || row.ma_nt || ''
  },
  {
    header: 'Loại chứng từ',
    width: 16,
    resolver: row => row.ma_ngv || ''
  }
];
